import IMAGES from 'src/_images/images.json';

const Logo = ({ className = '' }) => (
  <a href={devsite?.vimeo_url || 'https://www.vimeo.com'}>
    <img src={IMAGES.DARKLOGO} alt="vimeo logo" className={className} width="110px" height="31px" />
  </a>
);

export default Logo;
